<template>
	<div class="w-100">
		<div class="dropend w-100" :key="orgname">
			<div class="w-100" v-on:click="redirectOrgSetting()" :data-bs-toggle="canChangeOrg ? 'dropdown' : 'disabled'" aria-expanded="false">

				<div class="img-placeholder hide-mobile">{{ orgname.charAt(0) }}</div>

				<div class="hide-desktop text-center">{{ orgname }}</div>
				<div class="hide-toggle">
					<div class="sidebarLongName text-truncate">
						<span v-if="orgname != ''"  :title="orgname">
							{{ orgname }}
						</span>
						<span title="Select organisation" v-else>
							Select organisation
						</span>
					</div>
				</div>
				<div class="float-end hide-toggle" v-if="canChangeOrg">
					<i class="text-end fa fa-chevron-right"></i>
				</div>
			</div>
			<ul class="sidebar-popup dropdown-menu" v-if="canChangeOrg">

				<router-link class="text-end w-100 pe-3 btn btn-link text-dark" to="/dashboard">
					<i class="fa fa-angle-double-right"></i>
				</router-link>

				<li class="p-2 pt-0">
					<div class="search-org w-100 position-relative">
						<input type="" class="form-control pe-4" placeholder="Search" v-model="search">
						<i class="fa fa-search"></i>
					</div>
				</li>

				<li v-for="o in org" :key="o.id">
					<a class="dropdown-item" href="javascript:void(0)" v-on:click="selectOrg(o)">{{ o.name }}</a>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
	import { mapGetters, mapActions } from 'vuex';
	export default {
		name: 'orgnamecomponents',
		data() {
			return {
				org: null,
				search: "",
				orgname: ""
			}
		},
		computed: {
			...mapGetters('auth', ['isSuperAdmin', 'isPentester', 'isOrgAdmin']),
			...mapGetters('organisation', ['selectedOrganisation']),
			canChangeOrg() {
				// Logic to determine if the user can switch organisations
				return this.isSuperAdmin || this.isPentester;
			}
		},
		mounted() {
			this.setOrganisation();
			this.init("");
		},
		watch: {
			search(txt) {
				this.init(txt);
			},
			$route (to, from){
                this.setOrganisation();
			},
			selectedOrganisation(newOrg) {
				this.orgname = newOrg?.name || newOrg?.organisation || 'Select organisation';
			}
		},
		methods: {
			redirectOrgSetting() {
				if (this.isOrgAdmin && !this.canChangeOrg) {
					document.getElementById('toOrgSetting').click();
				}
			},
			setOrganisation() {
                // The watcher for selectedOrganisation will now handle this reactively.
                // We check the store first, which is populated by vuex-persistedstate on load.
                if (this.selectedOrganisation) {
                    this.orgname = this.selectedOrganisation.name || this.selectedOrganisation.organisation || "Select organisation";
                    this.$emit('callback', this.selectedOrganisation);
                } else {
                    this.orgname = 'Select organisation';
                }
			},
			init(txt) {
                // Use the computed properties from Vuex instead of $role
                if (this.isSuperAdmin || this.isPentester) {
                    this.$axios({
                        method: 'get',
                        url: this.$server + 'organisation?search=' + txt
                    })
                    .then(res => {
                        this.org = res.data.organisations;
                        // If no organisation is currently selected from the store,
                        // and we have a list of organisations, select the first one as a default.
                        if (!this.selectedOrganisation && this.org && this.org.length > 0) {
                            // We only commit the action to set the state, without triggering
                            // a full navigation like selectOrg() does.
                            this.selectOrganisationAction(this.org[0]);
                        }
                    });
                } else {
                    // Logic for OrgAdmins who can't search all orgs can go here.
                    // For now, they won't see a list, which is the current behavior.
                }
            },
			selectOrg(org) {
				this.selectOrganisationAction(org);
				this.$router.push({ path: "/" + org.id + "/dashboard" });
				setTimeout(()=>{
					document.getElementById("reloadSidebar").click();
				}, 100);
			},
			...mapActions('organisation', { selectOrganisationAction: 'selectOrganisation' })
		}
	}
</script>